module.exports = __webpack_public_path__ + "assets/img/account-add-btn.a959d512.svg";